// extracted by mini-css-extract-plugin
export default {"Search":"Search_Search__lboGW"};